const initialize = () => {
    const selects = document.querySelectorAll("select");
    for(const select of selects) {
        const options = select.querySelectorAll('option');
        for(const option of options) {
            if (option.getAttribute("selected")) {
                select.value = option.value;
            }
        }
    }
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    for(const checkbox of checkboxes) {
        checkbox.checked = checkbox.getAttribute("checked");
    }

    const labelInputs = document.querySelectorAll("[name*=ourFolder]");
    let i = 0;
    let defaultSubfolder = document.getElementById('folder-mapping-config').getAttribute('data-defaultsubfolder');

    if (!defaultSubfolder) {
        defaultSubfolder = 'INBOX';
    }
    for(const labelInput of labelInputs) {
        const labelEl = document.createElement('label');
        labelEl.classList.add('form-label');
        labelEl.style.minWidth = '200px';
        labelEl.setAttribute('for', 'folderMappingItems_' + i + '_theirFolder'); // + labelInput.parentNode.querySelector('[id$=ourFolder]').value
        labelEl.innerHTML = labelInput.value.replace('INBOX', '<span class="folder_prefix">'+ defaultSubfolder +'</span>');
        labelInput.parentNode.insertBefore(labelEl, labelInput.nextSibling);
        i++;
    }

    function onSubfolderChange(subFolderEl) {
        let subFolderValue = subFolderEl.value;
        if (!subFolderValue) {
            subFolderValue = 'INBOX';
        }
        const folderPrefixes = document.querySelectorAll(".folder_prefix");

        for(const folderPrefix of folderPrefixes) {
            folderPrefix.textContent = subFolderValue;
        }
    }

    function onPutToSubfolderChange(putToSubfolderEl) {
        const subFolderEl = document.querySelector("#subFolder");
        if (!putToSubfolderEl.checked) {
            subFolderEl.value = '';
            subFolderEl.readOnly = true;
            onSubfolderChange(subFolderEl);
        } else {
            subFolderEl.readOnly = false;
        }
    }

    function onCustomizeChange(customizeEl) {
        document.querySelector('#folderMappingItemsFieldset').style.display = customizeEl.checked ? 'block' : 'none';
    }

    const subFolderEl = document.querySelector("#subFolder");
    onSubfolderChange(subFolderEl);
    subFolderEl.addEventListener("input", function() {
        onSubfolderChange(subFolderEl);
    }, false);

    const customizeEl = document.querySelector("#customizeMapping");
    onCustomizeChange(customizeEl);
    customizeEl.addEventListener("input", function() {
        onCustomizeChange(customizeEl);
    }, false);

    var putToSubfolderEl = document.querySelector("#putToSubfolder");
    onPutToSubfolderChange(putToSubfolderEl);
    putToSubfolderEl.addEventListener("input", function() {
        onPutToSubfolderChange(putToSubfolderEl);
    }, false);
};

export default initialize;

